import * as types from '../constants/action.types';
import { IAction } from '../constants/action';
import documentService from '../api/document.service';

function requestDocument(): IAction {
    return { type: types.DOCUMENT_REQUESTED };
}

function documentReceived(id, html): IAction {
    return { type: types.DOCUMENT_RETRIEVED, data: { id, html } };
}

function documentFailed(error): IAction {
    return { type: types.DOCUMENT_FAILED, data: error };
}

function getDocument(id: string) {
    return dispatch => {
        dispatch(requestDocument());

        documentService.getEmbedDocument(id).then(html => {
            dispatch(documentReceived(id, html));
        }, err => {
            dispatch(documentFailed(err));
        });
    }
}

function shouldFetchDocument(state, id: string) {
    return typeof state.embeddedDocs[id] === 'undefined';
}

export function getDocumentIfNeeded(documentId: string) {
    return (dispatch, getState) => {
        if (shouldFetchDocument(getState(), documentId)) {
            return dispatch(getDocument(documentId));
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/document.action.ts